import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgCancel = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M12.564 1.308A11.33 11.33 0 0 0 1.241 12.645a11.32 11.32 0 0 0 4.36 8.936l-1.063 1.36a.226.226 0 0 0 .179.367l4.734-.023a.225.225 0 0 0 .218-.28l-1.12-4.602a.227.227 0 0 0-.4-.085l-1.153 1.477a9.246 9.246 0 0 1-.83-.737 9.034 9.034 0 0 1-2.657-6.413 9.034 9.034 0 0 1 2.656-6.413 9.034 9.034 0 0 1 6.416-2.656 9.034 9.034 0 0 1 6.413 2.656 9.034 9.034 0 0 1 2.656 6.413 9.034 9.034 0 0 1-3.32 7.014.225.225 0 0 0-.033.315l1.117 1.431c.079.1.223.117.323.037a11.316 11.316 0 0 0 4.184-8.797c0-6.268-5.086-11.346-11.357-11.337Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgCancel)
const Memo = memo(ForwardRef)
export default Memo
